export default {
  meta: {
    title: '资讯管理'
  }
};
